module.exports = new __parcel__URL__("leaderboard_xp_button_inactive.89a5722a.png").toString();